type MiaBrandProps = {
  compact?: boolean
  product?: string
  className?: string
}

export function MiaBrand({ compact = false, product = 'Enterprise AI', className = '' }: MiaBrandProps) {
  const classes = ['mia-brand', compact ? 'mia-brand-compact' : '', className].filter(Boolean).join(' ')
  return (
    <span className={classes} aria-label={`MIA ${product}`}>
      <img src="/brand/mia-symbol.png" alt="" width="58" height="47" decoding="async" />
      {!compact && <span className="mia-brand-copy"><strong>MIA</strong><small>{product}</small></span>}
    </span>
  )
}

export function MiaLogo({ className = '' }: { className?: string }) {
  return <img className={['mia-logo', className].filter(Boolean).join(' ')} src="/brand/mia-logo.png" alt="MIA" width="548" height="744" decoding="async" />
}
